module.exports = "../study/imgs/maps/Nagano/S8/Helth/HeatDisorder/Nagano_HeatDisorder_MIROC5_RCP45_End.png";